import LeadershipGrid from './LeadershipGrid'

export default LeadershipGrid
